import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import ApiConstants from 'src/common/helpers/ApiConstants';
import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
  putRequest,
} from 'src/common/helpers/HTTPRequest';
import { toastError, toastSuccess } from 'src/common/helpers/Notifications';
import TextConstants from 'src/common/helpers/TextConstants';
import { uploadS3File } from 'src/common/helpers/Utils';
import { HEATMAP_MEASUREMENTS_ACTION } from './actions';
import axios from 'axios';
import dayjs from 'dayjs';

function* getHeatmapMeasurements() {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.HEATMAP_MEASUREMENTS}`;
    const apiRes = yield call(getRequest, url, {});
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENTS_SUCCESS,
      payload: apiRes,
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENTS_FAILED,
      payload: {},
    });
  }
}

function* deleteHeatmapMeasurement({ payload, callbackFn }) {
  try {
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENTS_ID.replace(
      '{:measId}',
      payload.measId
    )}`;
    const apiRes = yield call(deleteRequest, url);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.DELETE_MEASUREMENT_SUCCESS,
      payload: apiRes,
    });
    toastSuccess(
      TextConstants.Common.DeletedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Measurement
      )
    );
    callbackFn && callbackFn();
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.DELETE_MEASUREMENT_FAILED,
      payload: {},
    });
  }
}

function* getHeatmapMeasurementDetails({ measId }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.HEATMAP_MEASUREMENTS}/${measId}`;
    const apiRes = yield call(getRequest, url, {});
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_DETAILS_SUCCESS,
      payload: apiRes,
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_DETAILS_FAILED,
      payload: {},
    });
  }
}

function* addMeasurement({ payload, callbackFn }) {
  try {
    const url = `${ApiConstants.BASE_URL}${ApiConstants.HEATMAP_MEASUREMENTS}`;
    const apiRes = yield call(postRequest, url, payload);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.ADD_MEASUREMENT_SUCCESS,
      payload: apiRes,
    });
    toastSuccess(
      TextConstants.Common.AddedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Measurement
      )
    );
    callbackFn && callbackFn(apiRes.measId);
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.ADD_MEASUREMENT_FAILED,
      payload: {},
    });
  }
}

function* updateHeatmapMeasurementSettings({ payload, callbackFn }) {
  try {
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENTS_ID.replace(
      '{:measId}',
      payload.measId
    )}`;
    const apiRes = yield call(patchRequest, url, payload);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.UPDATE_MEASUREMENT_SETTINGS_SUCCESS,
      payload: apiRes,
    });
    toastSuccess(
      TextConstants.Common.EditedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Measurement
      )
    );
    callbackFn && callbackFn();
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.UPDATE_MEASUREMENT_SETTINGS_FAILED,
      payload: {},
    });
  }
}

function* getHeatmapMeasurementAccessEmails({ measId }) {
  try {
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENTS_ACCESS.replace('{:measId}', measId)}`;
    const apiRes = yield call(getRequest, url, {});
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_SUCCESS,
      payload: apiRes,
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS_FAILED,
      payload: {},
    });
  }
}
function* getMeasurementAreasSaga({ measId }) {
  try {
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENT_AREAS.replace('{:measId}', measId)}`;
    const apiRes = yield call(getRequest, url, {});
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREAS_SUCCESS,
      payload: apiRes,
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREAS_FAILED,
      payload: {},
    });
  }
}

function* addAccessEmailsToHeatmapMeasurement({ payload, callbackFn }) {
  try {
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENTS_ACCESS.replace(
      '{:measId}',
      payload.measId
    )}`;
    const apiRes = yield call(postRequest, url, payload);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_SUCCESS,
      payload: apiRes,
    });
    toastSuccess(
      TextConstants.Common.AddedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Email
      )
    );
    callbackFn && callbackFn();
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS_FAILED,
      payload: {},
    });
  }
}

function* deleteAllEmailAccessOfHeatmapMeasurement({ measId, callbackFn }) {
  try {
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENTS_ACCESS.replace('{:measId}', measId)}`;
    yield call(deleteRequest, url);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_SUCCESS,
    });
    toastSuccess(
      TextConstants.Common.DeletedSuccessMessage.replace(
        '{item}',
        TextConstants.Common.Email
      )
    );
    callbackFn && callbackFn();
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS_FAILED,
    });
  }
}

function* updateAccessStatusOfHeatmapMeasurement({ payload, callbackFn }) {
  try {
    const { measId, enabled } = payload;
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENTS_ACCESS_STATE.replace(
      '{:measId}',
      measId
    )}`;
    yield call(putRequest, url, { enabled });
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_SUCCESS,
      payload: { enabled },
    });
    toastSuccess(
      TextConstants.Common.EditedSuccessMessage.replace(
        '{item}',
        TextConstants.HeatmapMeasurementDetail.Access
      )
    );
    callbackFn && callbackFn();
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS_FAILED,
    });
  }
}
function* getMeasurementAreaDetailsSaga({ payload: { measId, areaNo } }) {
  try {
    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENT_AREA_DETAILS.replace(
      '{:measId}',
      measId
    ).replace('{:areaNo}', areaNo)}`;
    const apiRes = yield call(getRequest, url, {});
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREA_DETAILS_SUCCESS,
      payload: apiRes,
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREA_DETAILS_FAILED,
      payload: {},
    });
  }
}

function* heatmapCustomerLogin({ payload, callbackFn }) {
  try {
    const { token, password } = payload;
    const url = `${ApiConstants.BASE_URL}${ApiConstants.HEATMAP_MEASUREMENTS_CUSTOMER_ACCESS_LOGIN}`;
    const apiRes = yield call(postRequest, url, { token, password }, false);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.DATA_SHARING_CUSTOMER_LOGIN_SUCCESS,
      payload: apiRes,
    });
    callbackFn && callbackFn();
  } catch (error) {
    console.log(error);
    toastError(error?.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.DATA_SHARING_CUSTOMER_LOGIN_ERROR,
    });
  }
}

function* saveMeasurementAreaSettingsSaga({
  payload: { measId, areaNo, data },
}) {
  try {
    const { name, mapFile, heights, heatmapMinMaxTemp, nodes } = data;
    const updates = {
      name,
      heights,
      heatmapMinMaxTemp,
      nodes,
    };

    if (mapFile) {
      // upload bg image
      const uploadUrl = `${
        ApiConstants.BASE_URL
      }${ApiConstants.HEATMAP_MEASUREMENT_AREA_MAP.replace(
        '{:measId}',
        measId
      ).replace('{:areaNo}', areaNo)}`;
      const extension = mapFile.filename.split('.').pop();
      const signedUrl = yield call(putRequest, uploadUrl, { extension });

      yield call(uploadS3File, signedUrl, mapFile.file);

      const { fields } = signedUrl;
      const fileKey = fields.key;
      updates.mapUrl = fileKey;
    }

    const url = `${
      ApiConstants.BASE_URL
    }${ApiConstants.HEATMAP_MEASUREMENT_AREA_DETAILS.replace(
      '{:measId}',
      measId
    ).replace('{:areaNo}', areaNo)}`;
    const apiRes = yield call(patchRequest, url, updates);

    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.SAVE_MEASUREMENT_AREA_SETTINGS_SUCCESS,
      payload: apiRes,
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.SAVE_MEASUREMENT_AREA_SETTINGS_FAILED,
      payload: {},
    });
  }
}

const getMeasurementCSVDataAsync = async (dataFileURL) => {
  return await axios.get(dataFileURL, {
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST',
    },
  });
};

function* getHeatmapMeasurementCSVData({ payload: { areaNo, dataFileURL } }) {
  try {
    const res = yield call(getMeasurementCSVDataAsync, dataFileURL);
    const blob = res.data;

    // Wrap FileReader in a promise
    const jsonText = yield new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function (event) {
        resolve(event.target.result);
      };
      reader.onerror = function (event) {
        reject(new Error('Failed to read file'));
      };
      reader.readAsText(blob);
    });
    const dataParsed = JSON.parse(jsonText);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_CSV_DATA_SUCCESS,
      payload: { [areaNo]: dataParsed },
    });
  } catch (e) {
    toastError(e.message);
    yield put({
      type: HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_CSV_DATA_FAILED,
      payload: {},
    });
  }
}

export function* getHeatmapMeasurementsSaga() {
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENTS,
    getHeatmapMeasurements
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.DELETE_MEASUREMENT,
    deleteHeatmapMeasurement
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_DETAILS,
    getHeatmapMeasurementDetails
  );
  yield takeLatest(HEATMAP_MEASUREMENTS_ACTION.ADD_MEASUREMENT, addMeasurement);
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.UPDATE_MEASUREMENT_SETTINGS,
    updateHeatmapMeasurementSettings
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_ACCESS_EMAILS,
    getHeatmapMeasurementAccessEmails
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_ADD_ACCESS_EMAILS,
    addAccessEmailsToHeatmapMeasurement
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_DELETE_ALL_ACCESS_EMAILS,
    deleteAllEmailAccessOfHeatmapMeasurement
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.HEATMAP_MEASUREMENT_UPDATE_ACCESS_STATUS,
    updateAccessStatusOfHeatmapMeasurement
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.DATA_SHARING_CUSTOMER_LOGIN,
    heatmapCustomerLogin
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREAS,
    getMeasurementAreasSaga
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.GET_MEASUREMENT_AREA_DETAILS,
    getMeasurementAreaDetailsSaga
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.SAVE_MEASUREMENT_AREA_SETTINGS,
    saveMeasurementAreaSettingsSaga
  );
  yield takeLatest(
    HEATMAP_MEASUREMENTS_ACTION.GET_HEATMAP_MEASUREMENT_CSV_DATA,
    getHeatmapMeasurementCSVData
  );
}

export default function* () {
  yield all([fork(getHeatmapMeasurementsSaga)]);
}
